import mapValues from 'lodash/mapValues';
import concat from 'lodash/concat';
import CreditCard from '../components/CreditCard';
import ECheck from '../components/ECheck';
import Check from '../components/Check';
import Pinpad from '../components/Pinpad';
import ApplePay from '../components/ApplePay';
import GooglePay from '../components/GooglePay';
import IdealPay from '../components/IdealPay';
import Cash from '../components/Cash';
import paymentMethodsMap from '../../../../../../shared/config/paymentMethodsMap';
import { checkApplePaySupport } from '../utils/applePayUtils';

const CONFIG = {};

CONFIG.CREDIT_CARD = {
  active: true,
  type: 'creditCard',
  text: paymentMethodsMap.CREDIT_CARD,
  icon: 'ic-payment-card',
  component: CreditCard,
  showTitle: true,
};

CONFIG.ECHECK = {
  active: true,
  type: 'eCheck',
  text: paymentMethodsMap.ECHECK,
  icon: 'ic-e-check',
  component: ECheck,
  showTitle: true,
};

CONFIG.CHECK = {
  active: true,
  type: 'check',
  text: paymentMethodsMap.CHECK,
  icon: 'ic-payment-check',
  component: Check,
  showTitle: true,
};

CONFIG.CASH = {
  active: true,
  type: 'cash',
  text: paymentMethodsMap.CASH,
  icon: 'ic-money',
  component: Cash,
  showTitle: false,
};

CONFIG.PINPAD = {
  active: true,
  type: 'pinpad',
  text: paymentMethodsMap.PINPAD,
  icon: 'ic-calculator',
  component: Pinpad,
  showTitle: true,
};

CONFIG.ALIPAY = {
  active: false,
  type: 'alipay',
  text: paymentMethodsMap.ALIPAY,
  icon: 'ic-alipay',
  showTitle: true,
};

CONFIG.WECHAT = {
  active: false,
  type: 'wechatPay',
  text: paymentMethodsMap.WECHAT,
  icon: 'ic-wechat-pay',
  showTitle: true,
};

CONFIG.APPLEPAY = {
  active: true,
  type: 'applePay',
  text: paymentMethodsMap.APPLEPAY,
  icon: 'apple-pay-icon',
  component: ApplePay,
  showTitle: false,
};

CONFIG.GOOGLEPAY = {
  active: true,
  type: 'googlePay',
  text: paymentMethodsMap.GOOGLEPAY,
  icon: 'google-pay-icon',
  component: GooglePay,
  showTitle: false,
};

CONFIG.IDEAL = {
  active: true,
  type: 'idealPay',
  text: paymentMethodsMap.IDEAL,
  icon: 'ideal-pay-icon',
  component: IdealPay,
  showTitle: true,
};

const getSupportTypesOrder = () => {
  const activeObj = mapValues(CONFIG, c => c.active);
  return Object.keys(activeObj);
};

export const methodsOrder = getSupportTypesOrder();

export const getActiveTypes = () => {
  const activeObj = mapValues(CONFIG, c => c.active);
  return Object.keys(activeObj).filter(k => !!activeObj[k] && k !== 'GOOGLEPAY' && k !== 'APPLEPAY');
};

export const getSupportTypes = async (params, googlePayment) => {
  let supportTypeList = getActiveTypes();
  const {
    googlePayInfo, applePayInfo,
    paymentCountryCode, i18n, enablePreviewMode,
  } = params;
  if (checkApplePaySupport({
    applePayInfo, paymentCountryCode,
  })) {
    supportTypeList = concat(supportTypeList, [ 'APPLEPAY' ]);
  }
  const googleResult = await googlePayment.checkGooglePaySupport?.({
    paymentCountryCode, googlePayInfo, i18n, enablePreviewMode,
  });
  if (googleResult) {
    supportTypeList = concat(supportTypeList, [ 'GOOGLEPAY' ]);
  }
  return supportTypeList;
};

export default CONFIG;
